module.exports = __webpack_public_path__ + "img/technology6.6c703946.png";